"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _Button = _interopRequireDefault(require("@mui/material/Button"));
var _theme = require("../theme");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/**
 *
 * @param {*} props
 */
var Button = function Button(props) {
  var onClick = props.onClick,
    customStyle = props.customStyle,
    className = props.className,
    variant = props.variant,
    transparent = props.transparent,
    marginTop = props.marginTop,
    marginBottom = props.marginBottom,
    children = props.children,
    disabled = props.disabled,
    fullWidth = props.fullWidth,
    _props$color = props.color,
    color = _props$color === void 0 ? "default" : _props$color,
    id = props.id,
    testid = props.testid,
    noHover = props.noHover,
    tabIndex = props.tabIndex;

  /**
   * 
   * @returns 
   */
  var setHoverColor = function setHoverColor() {
    if (noHover) {
      return null;
    }
    if (color === "white") {
      return "#d5d5d5";
    }
    return color === "default" && _theme.colors.hoverGrey;
  };

  /**
  * 
  * @returns the styles to be applied if the transparent prop is applied to the component
  */
  var setTransparentStyles = function setTransparentStyles() {
    if (transparent) {
      return {
        width: 'fit-content',
        boxShadow: 'none',
        backgroundColor: _theme.colors.clear,
        fontSize: _theme.fonts.size.label,
        paddingLeft: '10px',
        paddingRight: '10px',
        color: _theme.colors.darkBlue,
        '&:hover': {
          backgroundColor: "#d5d5d5"
        }
      };
    }
    return {};
  };
  var style = _objectSpread(_objectSpread({
    fontFamily: _theme.fonts.type.heading,
    letterSpacing: "0.02857em",
    whiteSpace: "nowrap",
    marginTop: marginTop || 0,
    marginBottom: marginBottom || 0,
    width: fullWidth ? "100%" : "auto",
    transition: className && 'all 0.2s ease',
    '&:hover': {
      backgroundColor: setHoverColor()
    }
  }, setTransparentStyles()), customStyle);
  if (color === 'white') {
    style.backgroundColor = "#FFF";
  }
  return /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    id: id || testid,
    color: color,
    disabled: disabled,
    variant: variant || "contained",
    sx: style,
    onClick: onClick,
    tabIndex: tabIndex
  }, children);
};
var _default = exports["default"] = Button;